const startCaseCode = `import { startCase } from 'cristatus';

// Convert a string to start case.
const startCaseString = startCase("hello_world"); //Hello World
`;

export default startCaseCode;
